import React, { useState } from "react";
import { PanelScaleSettingsStyle } from "../utils/PanelScaleSettingsStyle";
import { useDispatch } from "react-redux";
import { ROL_USER } from "../../../../app/api-client/constants";
import { updateEvbi } from "../../../domain/api/EvbiApi";
import { Button, Grid, FormControl, InputLabel, OutlinedInput, CircularProgress, Select, MenuItem } from "@material-ui/core";
import { Store } from "react-notifications-component";

export const EditarEvbi = ({ data, clear, inputStyles }) => {


    const [id] = useState(data.id);
    const [nombre, setNombre] = useState(data.name);
    const [sendWhatsapp, setSendW] = useState(data.send_whatsapp);
    const [sendSms, setSendS] = useState(data.send_sms);
    const [sendEmail, setSendE] = useState(data.send_email);
    const classes = PanelScaleSettingsStyle();
    const [isLoanding, setisLoanding] = useState(false);
    const dispatch = useDispatch();
    const rol = localStorage.getItem(ROL_USER);
    
    const handledAlert = (title, message, type) => {
        Store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 5000,
                onScreen: true
            }
        });
        setTimeout(() => {
            // init()
        }, 1000);
    }

    let Request = {
        id: id,
        nombre: nombre,
        hashPoll: 0,
        sendWhatsapp: sendWhatsapp,
        sendSms: sendSms,
        sendEmail: sendEmail,
        ubicacion: data.ubicacion.id
    }

    const editar = async (e) => {
        try {
            setisLoanding(true);
            const [, historico] = await updateEvbi(dispatch, Request);
            setisLoanding(false);
            handledAlert("Actualizado Exitosamente!", `Evbi actualizada !`, "success")
            clear();
        } catch (err) {
            console.log("Ocurrio un error", err);
            setisLoanding(false);
        }
    };

    return (
        <form>
            {rol === "ROLE_ADMIN" &&
                <Grid container spacing={3} style={{ textAlign: "left" }}>
                    <Grid item xs={12} md={12} sm={12}>
                        <FormControl fullWidth variant="outlined">

                            <OutlinedInput
                                id="nombre"
                                type="nombre"
                                name='nombre'
                                onChange={(e) => setNombre(e.target.value)}
                                label="nombre"
                                value={nombre}
                                style={inputStyles}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={12} sm={12}>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel htmlFor="tipo" style={{ marginTop: '-1%' }}>Desea recibir whatsapp</InputLabel>
                            <Select
                                labelId="demo-simple-select-outlined-label"
                                onChange={(e) => setSendW(e.target.value)}
                                value={sendWhatsapp}
                                label="Desea recibir whatsapp"
                                style={inputStyles}
                            >
                                <MenuItem value="">
                                    <em>seleccione</em>
                                </MenuItem>
                                <MenuItem value={true}>SI</MenuItem>
                                <MenuItem value={false}>NO</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={12} sm={12}>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel htmlFor="tipo" style={{ marginTop: '-1%' }}>Desea recibir SMS</InputLabel>
                            <Select
                                labelId="demo-simple-select-outlined-label"
                                onChange={(e) => setSendS(e.target.value)}
                                value={sendSms}
                                label="Desea recibir SMS"
                                style={inputStyles}
                            >
                                <MenuItem value="">
                                    <em>seleccione</em>
                                </MenuItem>
                                <MenuItem value={true}>SI</MenuItem>
                                <MenuItem value={false}>NO</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={12} sm={12}>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel htmlFor="tipo" style={{ marginTop: '-1%' }}>Desea recibir Email</InputLabel>
                            <Select
                                labelId="demo-simple-select-outlined-label"
                                value={sendEmail}
                                onChange={(e) => setSendE(e.target.value)}
                                label="Desea recibir emails"
                                style={inputStyles}

                            >
                                <MenuItem value="">
                                    <em>seleccione</em>
                                </MenuItem>
                                <MenuItem value={true}>SI</MenuItem>
                                <MenuItem value={false}>NO</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            }

            {rol !== "ROLE_ADMIN" &&
                <Grid container spacing={3} style={{ textAlign: "left" }}>

                </Grid>
            }

            <div className={classes.wrapper}>
                <Grid container justifyContent="space-between" style={{ marginTop: '10px' }}>
                    <Button
                        disabled={isLoanding}
                        type="submit"
                        variant="contained"
                        color="primary"
                        style={{ textTransform: "none", width: "48%", borderRadius: '10px' }}
                        onClick={editar}
                    >
                        Editar Evbi
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        style={{ textTransform: "none", width: "48%", borderRadius: '10px' }}
                        onClick={clear}
                    >
                        Cancelar
                    </Button>
                </Grid>
                {isLoanding && <CircularProgress size={24} className={classes.buttonProgress} />}
            </div>
        </form>
    )
}
